export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB'];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const unit = units[Math.min(i, units.length - 1)];
  const value = bytes / Math.pow(k, i);

  if (unit === 'B') return `${Math.round(value)} B`;
  return `${value.toFixed(1)} ${unit}`;
}

export function validateFileSize(file: File, maxSizeBytes: number): string | null {
  if (file.size > maxSizeBytes) {
    return `File too large: ${formatBytes(file.size)}. Maximum size is ${formatBytes(maxSizeBytes)}.`;
  }
  return null;
}
